module.exports = __webpack_public_path__ + "img/01800Cerveza.95d219df.png";